import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "row-stretch" }
const _hoisted_2 = ["placeholder", "autoFocus"]
const _hoisted_3 = {
  key: 0,
  class: "es-cancel-button"
}
const _hoisted_4 = { class: "row-stretch" }
const _hoisted_5 = {
  key: 0,
  style: {"position":"absolute"},
  class: "w-full"
}
const _hoisted_6 = { class: "dropdown" }

import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import stylesJS from '@/assets/styles.js';


export default /*@__PURE__*/_defineComponent({
  __name: 'inputComboBox2',
  props: /*@__PURE__*/_mergeModels({
  styles: {
    type: String,
    default: ""
  },
  placeholder: {
    type: String,
    default: ""
  },
  hasDropd: {
    type: Boolean,
    default: true
  },
  hasClearBtn: {
    type: Boolean,
    default: true
  },  
  autoFocus: {
    type: Boolean,
    default: false
  },
  minHeight: {
    type: Boolean,
    default: false
  }
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['blur', 'keyupEnter'], ["update:modelValue"]),
  setup(__props, { expose: __expose, emit: __emit }) {

const inputValue = _useModel(__props, "modelValue");
const props = __props;

const emits = __emit;

function emitBlur() {
  emits('blur')
}

function emitEnter() {
  emits('keyupEnter')
}

const innerRef = ref(null);

__expose({
  innerRef,
  hideDropdown,
});

const showDropdown = ref(false);

const classList = computed(() => {
  // Import & defaults
  let importOBJ = stylesJS.get(props.styles)
  let iAlign = importOBJ.align || "l"
  iAlign = "align-" + iAlign
  let iMain = importOBJ.main || "h"
  iMain = "main-" + iMain
  let iBg = importOBJ.bg || "0"
  iBg = "bg-" + iBg
  let iFont = importOBJ.font || "m"
  iFont = "font-" + iFont
  let iPad = importOBJ.pad  || "m"
  iPad = "pad-" + iPad
  let iPLeft = importOBJ.pleft  || "08"
  iPLeft = "pleft-" + iPLeft

  return ['component', 'border-none', iMain, iAlign, iBg, iFont, iPad, iPLeft]
});

function clearFCT() {
  inputValue.value = ''
  setTimeout(() => {
    innerRef.value.focus()
  }, 50)  
}

function hideDropdown() {
  showDropdown.value = false
}

//Logic for closing
const mainDiv = ref(null);
const handleClickOutside = (event) => {
  if (!mainDiv.value || !mainDiv.value.contains(event.target)) {
    hideDropdown();
  }
}

onMounted(() => {
  if(props.autoFocus) {
    innerRef.value.focus();
  }
  document.addEventListener('click', handleClickOutside, true); // Use capture phase
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside, true); // Use capture phase
});


return (_ctx: any,_cache: any) => {
  const _component_es_button_icon = _resolveComponent("es-button-icon")!
  const _component_inputBox = _resolveComponent("inputBox")!

  return (_openBlock(), _createElementBlock("div", _mergeProps({
    ref_key: "mainDiv",
    ref: mainDiv
  }, _ctx.$attrs, { style: {"min-width":"5rem","position":"relative"} }), [
    _createVNode(_component_inputBox, {
      class: _normalizeClass(["row-stretch", __props.hasDropd && showDropdown.value === true ? 'rnd-top-s' : 'rnd-full'])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "pre")
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["row-stretch w-full", __props.minHeight ? 'select-height' : '']),
          style: {"margin-right":"auto","margin-left":"auto"}
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            ref_key: "innerRef",
            ref: innerRef,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
            placeholder: showDropdown.value ? '' : props.placeholder,
            class: _normalizeClass(classList.value),
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (showDropdown.value = true)),
            onBlur: _cache[2] || (_cache[2] = ($event: any) => (emitBlur())),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (emitEnter()), ["enter"])),
            autoFocus: __props.autoFocus
          }, null, 42, _hoisted_2), [
            [_vModelText, inputValue.value]
          ]),
          (__props.hasClearBtn && inputValue.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_es_button_icon, {
                  icon: "xmark",
                  folder: "shareIcons",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (clearFCT())),
                  styles: "img-grey"
                })
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "post")
        ])
      ]),
      _: 3
    }, 8, ["class"]),
    (__props.hasDropd && showDropdown.value === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_inputBox, {
            class: "input-bg rnd-bottom-s",
            style: {"position":"relative","z-index":"1"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "dropd")
              ])
            ]),
            _: 3
          })
        ]))
      : _createCommentVNode("", true)
  ], 16))
}
}

})